<script>
    import app from "../stores/app";
    import {ROUTE_TYPE, ROUTE_TYPES, LOCATION_TYPE} from "../lib/constants";
    import RouteLocation from "../components/controls/RouteLocation.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    export let routeType;
    export let pickup;
    export let drop;
    export let disableSwitch = false;
    export let disableFrom = false;
    export let defaultLocations = [];

    const switchRoute = () => {
        let temp = pickup;
        pickup = drop;
        drop = temp;
    }

    $: {
        routeType = ROUTE_TYPE.TRANSFER;

        if (pickup && drop) {
            if (pickup.type_id == LOCATION_TYPE.AIRPORT || pickup.type_id == LOCATION_TYPE.PORT) {
                routeType = ROUTE_TYPE.ARRIVAL;
            } else if (drop.type_id == LOCATION_TYPE.AIRPORT || drop.type_id == LOCATION_TYPE.PORT) {
                routeType = ROUTE_TYPE.DEPARTURE;
            }
        }
    }
</script>


<div class="route">
    <legend class="fw-semibold" class:departure={ routeType == ROUTE_TYPE.DEPARTURE}
            class:arrival={ routeType == ROUTE_TYPE.ARRIVAL}>
        { ROUTE_TYPES[routeType] }

        {#if !disableSwitch}
            <button class="btn btn-primary btn-sm px-3" title="switch locations"
                    on:click="{ switchRoute }">
                <AppIcon icon="arrows-h" size="16"/>
            </button>
        {/if}
    </legend>
    <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6">
            <div class="form-group">
                <label>From</label>
                <RouteLocation {defaultLocations} bind:location="{ pickup }" placeholder="location name"
                               disabled="{ disableFrom }"/>
            </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6">
            <div class="form-group">
                <label>To</label>
                <RouteLocation {defaultLocations} bind:location="{ drop }"
                               excludeLocation="{ pickup }" placeholder="location name"/>
            </div>
        </div>
    </div>
</div>

<style>
    .route {
        /*margin-bottom: 15px;*/
    }

    .route .arrival {
        color: #fff;
        background: var(--route-arrival-color);
    }

    .route .departure {
        color: #fff;
        background: var(--route-departure-color);
    }
</style>